import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Updates from './components/Updates';
import ThemeIndex from './components/ThemeIndex';
import FocusCarousel from './components/FocusCarousel';
import MediaCards from './components/MediaCards';
import ContactEntry from './components/ContactEntry';
import TopicTags from './components/TopicTags';
import AppEntry from './components/AppEntry';
import InfoCards from './components/InfoCards';
import About from './components/About';
import Ranking from './components/Ranking';
import Faq from './components/Faq';
import Features from './components/Features';
import Comments from './components/Comments';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <Hero />

        <Updates />

        <ThemeIndex />

        <FocusCarousel />

        <MediaCards />

        <ContactEntry />

        <TopicTags />

        <AppEntry />

        <InfoCards />

        <About />

        <Ranking />

        <Faq />

        <Features />

        <Comments />
      </main>

      <Footer />
    </>
  );
}